module.exports = __webpack_public_path__ + "img/news-9.88684c86.png";